import numeral from "numeral";
import { useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useDebtStore } from "../../../_store/debtplanStore";
import { useEducationStore } from "../../../_store/educationStore";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { useRetireStore } from "../../../_store/retireStore";
import { useUserStore } from "../../../_store/userStore";
import {
  DonutChartEmpty,
  DonutChartMain,
} from "../../../components/chart/DonutChartMain";
import { cn } from "../../../utils/useFunctions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_13,
  STYLE_PDF_TEXT_MEDIUM_BLUE_13,
} from "../styles/pdf.style";
import { SumSaving } from "../../../functions/Balance/sumSaving";
import { SumVariableExpense } from "../../../functions/Balance/sumVariableExpense";
import { calculateExpenseSummary } from "../../../functions/Balance/expense-summary";

// แสดงสัดส่วนรายจ่ายเดิมและเพิ่มหมายเหตุเฉพาะเงินสดคงเหลือบวกจาก owner กลาง โดยไม่คำนวณจาก net cash flow ภายในหน้า PDF
function PdfPageOVExpenseOne({ page }) {
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const educationData = useEducationStore((state) => state.educationData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const debtData = useDebtStore((state) => state.debtData);
  const userData = useUserStore((state) => state.userData);
  const retireData = useRetireStore((state) => state.retireData);

  const [addExpensesVariable, setAddExpensesVariable] = useState(
    balanceData?.expenses_variable_list
      ? balanceData.expenses_variable_list
      : []
  );

  const [addExpensesInvest, setAddExpensesInvest] = useState(
    balanceData?.expenses_invest_saving_list
      ? balanceData.expenses_invest_saving_list
      : []
  );

  const expenseSummary = useMemo(
    () => calculateExpenseSummary(balanceData),
    [balanceData]
  );
  const positiveResidualAllocation =
    expenseSummary.positiveResidualAllocation;

  const netCashFlow = useMemo(() => {
    return (
      balanceData?.sum_salary_peryear +
      balanceData?.sum_interest_peryear +
      balanceData?.sum_other_income -
      (balanceData?.sum_expenses_fixed +
        SumSaving(addExpensesInvest) +
        SumVariableExpense(addExpensesVariable))
    );
  }, [balanceData]);

  const createSumObject = (sum_per_month, sum_per_year, sum_percent) => ({
    sum_per_month: sum_per_month || 0,
    sum_per_year: sum_per_year || 0,
    sum_percent: sum_percent || 0,
  });

  const sumFixed = useMemo(() => {
    return createSumObject(
      balanceData?.sum_expenses_fixed / 12,
      balanceData?.sum_expenses_fixed,
      (balanceData?.sum_expenses_fixed / balanceData?.expenses_propotion) * 100
    );
  }, [balanceData]);

  const sumVariable = useMemo(() => {
    return createSumObject(
      balanceData?.sum_expenses_variable / 12,
      balanceData?.sum_expenses_variable,
      (balanceData?.sum_expenses_variable / balanceData?.expenses_propotion) *
        100
    );
  }, [balanceData]);

  const sumExpensesInvestSaving = useMemo(() => {
    return createSumObject(
      (netCashFlow + SumSaving(addExpensesInvest) < 0
        ? 0
        : netCashFlow + SumSaving(addExpensesInvest)) / 12,
      netCashFlow + SumSaving(addExpensesInvest) < 0
        ? 0
        : netCashFlow + SumSaving(addExpensesInvest),
      ((netCashFlow + SumSaving(addExpensesInvest) < 0
        ? 0
        : netCashFlow + SumSaving(addExpensesInvest)) /
        balanceData?.expenses_propotion) *
        100
    );
  }, [balanceData]);

  const sumTotal = useMemo(
    () => Number(balanceData?.sum_expenses_fixed || 0) +
              Number(balanceData?.sum_expenses_variable || 0) +
              Number(balanceData?.sum_expenses_invest_saving || 0),
    [balanceData]
  );

  const items = useMemo(() => {
    return [
      {
        title: "ค่าใช้จ่ายคงที่",
        icon: "accounting.svg",
        ...sumFixed,
      },
      {
        title: "ค่าใช้จ่ายแปรผัน",
        icon: "cost (1).svg",
        ...sumVariable,
      },
      {
        title: "ค่าใช้จ่ายเพื่อการออม/ลงทุน",
        icon: "bank.svg",
        classNameIcon: "w-[24px]",
        ...sumExpensesInvestSaving,
      },
    ];
  }, [sumTotal]);

  return (
    <div
      style={{
        backgroundImage: `url(/images/bg_pdf.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
      }}
      className={cn(STYLE_PAGE)}
    >
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="สัดส่วนรายจ่ายของคุณ" icon="/images/payment.svg" />
      <PdfCard>
        <PdfCardWhite>
          {/* <div className={cn("text-center", STYLE_PDF_TEXT_MEDIUM_12)}>
            คุณมีรายจ่ายทั้งหมด
          </div> */}

          <div className="">
            {Number(balanceData?.sum_expenses_fixed || 0) +
        Number(balanceData?.sum_expenses_variable || 0) +
        Number(balanceData?.sum_expenses_invest_saving || 0) <=
        0 ||
      isNaN(
        Number(balanceData?.sum_expenses_fixed || 0) +
          Number(balanceData?.sum_expenses_variable || 0) +
          Number(balanceData?.sum_expenses_invest_saving || 0)
      ) ? (
              <DonutChartEmpty text={`รายจ่าย`} />
            ) : (
              <DonutChartMain
                text={`ค่าใช้จ่าย`}
                value={numeral(Number(balanceData?.sum_expenses_fixed || 0) +
              Number(balanceData?.sum_expenses_variable || 0) +
              Number(balanceData?.sum_expenses_invest_saving || 0)).format("0,0")}
                // defalut={getOutcomeBalance > 0 ? 0 : 100}
                data1={balanceData?.sum_expenses_fixed}
                data2={balanceData?.sum_expenses_variable}
                data3={
                  netCashFlow + SumSaving(addExpensesInvest) < 0
                    ? 0
                    : netCashFlow + SumSaving(addExpensesInvest)
                }
                labelLists={[
                  {
                    label: "ค่าใช้จ่ายคงที่",
                    value: balanceData?.sum_expenses_fixed,
                    color: "#F4B331",
                  },
                  {
                    label: "ค่าใช้จ่ายแปรผัน",
                    value: balanceData?.sum_expenses_variable,
                    color: "#FF434A",
                  },
                  {
                    label: "ค่าใช้จ่ายเพื่อการออม/ลงทุน",
                    value:
                      netCashFlow + SumSaving(addExpensesInvest) < 0
                        ? 0
                        : netCashFlow + SumSaving(addExpensesInvest),
                    color: "#16AA37",
                  },
                ]}
                classNameGray={"bg-white"}
                isRemoveGray
                isRemoveLegend
                classNameDonut={"w-[200px] top-4 mb-2"}
                classNameText={cn("text-lg")}
                classNameValue={cn("text-lg")}
              />
            )}
          </div>

          <div
            className={cn(
              "grid grid-cols-5 px-3 items-center",
              STYLE_PDF_TEXT_MEDIUM_12
            )}
          >
            <div className="col-span-2">รายจ่าย</div>
            <div className={cn("text-right")}>ต่อเดือน (บาท)</div>
            <div className={cn("text-right")}>ต่อปี (บาท)</div>
            <div className={cn("text-right")}>%</div>
          </div>
          <PdfLine className={"mb-1 mt-1"} />

          <div className="flex flex-col space-y-2">
            {items?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={cn(
                    "grid grid-cols-5 px-3 items-center",
                    STYLE_PDF_TEXT_MEDIUM_12
                  )}
                >
                  <div className="flex space-x-2 col-span-2">
                    <div>
                      <img
                        className={cn(item?.classNameIcon)}
                        src={`/images/${item.icon}`}
                      />
                    </div>
                    <div>{item.title}</div>
                  </div>
                  <div className="text-right">
                    {numeral(item.sum_per_month).format("0,0")}
                  </div>
                  <div className="text-right">
                    {numeral(item.sum_per_year).format("0,0")}
                  </div>
                  <div className="text-right">
                    {numeral(
                      (item?.sum_per_year /
                        (items[0]?.sum_per_year +
                          items[1]?.sum_per_year +
                          items[2]?.sum_per_year)) *
                        100
                    ).format("0.00")}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex justify-center items-center space-x-1 mt-2">
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_13)}>
              รวมรายจ่ายทั้งหมด
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13)}>
              {numeral(sumTotal).format("0,0")}
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13)}>บาท</div>
          </div>
          {positiveResidualAllocation > 0 && (
            <div
              className={cn(
                "mx-auto mt-1 mb-2 max-w-[460px] px-4 text-center whitespace-normal break-words leading-[1.35]",
                STYLE_PDF_TEXT_MEDIUM_12
              )}
            >
              {`จากกระแสเงินสดสุทธิ ${numeral(
                positiveResidualAllocation
              ).format("0,0")} บาท ให้สมมติฐานว่านำมาบันทึกเป็นค่าใช้จ่ายเพื่อออมและลงทุน`}
            </div>
          )}
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageOVExpenseOne;
